import * as React from "react";
import {
  Button,
  FormControl, InputLabel, Select, MenuItem,
  Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  Box
} from "../../components/mui";
import {
  SearchRoundedIcon, RestartAltRoundedIcon, GetAppRoundedIcon, EventAvailableRoundedIcon
} from "../../components/icons";

import "../../styles/main.css";
import "../../styles/pages/stayInHistory.css";
import PageLayout from "../../components/shared/PageLayout";
import PageHeader from "../../components/shared/PageHeader";
import DataTableCard from "../../components/shared/DataTableCard";

// Hardcoded filter options - Backend developer will replace with API calls
const FILTER_OPTIONS = {
  year: [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
    { value: "2022", label: "2022" },
    { value: "2021", label: "2021" },
    { value: "2020", label: "2020" }
  ],
  month: [
    { value: "all", label: "All" },
    { value: "january", label: "January" },
    { value: "february", label: "February" },
    { value: "march", label: "March" },
    { value: "april", label: "April" },
    { value: "may", label: "May" },
    { value: "june", label: "June" },
    { value: "july", label: "July" },
    { value: "august", label: "August" },
    { value: "september", label: "September" },
    { value: "october", label: "October" },
    { value: "november", label: "November" },
    { value: "december", label: "December" }
  ],
  company: [
    { value: "all", label: "All" },
    { value: "avantico-carp", label: "Avantico Carp" },
    { value: "caspo-inc", label: "Caspo Inc" }
  ],
  condoSharing: [
    { value: "all", label: "All" },
    { value: "not-shared", label: "Not Shared" },
    { value: "shared", label: "Shared" },
    { value: "shared-concerto", label: "Shared - Concerto" }
  ]
};

// Hardcoded stay-in history data - Backend developer will replace with API calls
const STAY_IN_HISTORY_DATA = [
  {
    id: 1,
    eid: "1561",
    fullName: "Ferna",
    nickname: "Ferna",
    gender: "F",
    ranking: "10",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[409] Payment & Account Support",
    team: "EA Deposit Other Methods Team 1",
    nationality: "Indonesian",
    onBoardDate: "10/07/2023",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 2,
    eid: "1562",
    fullName: "Amie",
    nickname: "Amie",
    gender: "F",
    ranking: "11",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[418] Marketing (VN)",
    team: "SEA Vietnam",
    nationality: "Vietnamese",
    onBoardDate: "10/07/2023",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 3,
    eid: "1583",
    fullName: "SJ",
    nickname: "SJ",
    gender: "M",
    ranking: "10",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Product & Innovation",
    department: "[408] Product",
    team: "Product Marketing",
    nationality: "Thai",
    onBoardDate: "18/09/2023",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 4,
    eid: "1584",
    fullName: "Michael",
    nickname: "Michael",
    gender: "M",
    ranking: "9",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Business Intelligence",
    department: "[132] Business Intelligence",
    team: "Business Intelligence",
    nationality: "Burmese",
    onBoardDate: "02/10/2023",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 5,
    eid: "1598",
    fullName: "Duong Tran Uyen Phuong",
    nickname: "Uyen",
    gender: "F",
    ranking: "10",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "ACX",
    nationality: "Vietnamese",
    onBoardDate: "02/01/2024",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 6,
    eid: "1599",
    fullName: "Vincent",
    nickname: "Vincent",
    gender: "M",
    ranking: "11",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "EA China",
    nationality: "Malaysian",
    onBoardDate: "02/01/2024",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 7,
    eid: "CN043",
    fullName: "Lu",
    nickname: "Lu",
    gender: "M",
    ranking: "1",
    designation: "Operations Analyst",
    company: "Caspo Inc",
    division: "Operations Management",
    department: "Straight",
    team: "Team 2a",
    nationality: "Chinese",
    onBoardDate: "22/09/2005",
    lastDorm: "15/11/2024",
    condoSharing: "Not Shared"
  },
  {
    id: 8,
    eid: "ID001",
    fullName: "Eddy",
    nickname: "Eddy",
    gender: "M",
    ranking: "7",
    designation: "Manager",
    company: "Caspo Inc",
    division: "Operations Management",
    department: "RB",
    team: "America",
    nationality: "Indonesian",
    onBoardDate: "02/08/2003",
    lastDorm: "01/11/2024",
    condoSharing: "Not Shared"
  },
  {
    id: 9,
    eid: "ID002",
    fullName: "Jack",
    nickname: "Jack",
    gender: "M",
    ranking: "7",
    designation: "Head of Operations Management",
    company: "Caspo Inc",
    division: "Operations Management",
    department: "Management CP",
    team: "Management CP",
    nationality: "Indonesian",
    onBoardDate: "01/08/2003",
    lastDorm: "",
    condoSharing: "Not Shared"
  },
  {
    id: 10,
    eid: "ID003",
    fullName: "Amin",
    nickname: "Amin",
    gender: "M",
    ranking: "5",
    designation: "Supervisor",
    company: "Caspo Inc",
    division: "Operations Management",
    department: "RB",
    team: "Euro",
    nationality: "Indonesian",
    onBoardDate: "16/08/2003",
    lastDorm: "15/11/2024",
    condoSharing: "Not Shared"
  },
  {
    id: 11,
    eid: "ID011",
    fullName: "Tony",
    nickname: "Tony",
    gender: "M",
    ranking: "1",
    designation: "Operations Analyst",
    company: "Caspo Inc",
    division: "Operations Management",
    department: "RB",
    team: "Euro",
    nationality: "Indonesian",
    onBoardDate: "29/11/2004",
    lastDorm: "15/11/2024",
    condoSharing: "Shared - Concerto"
  }
];

function StayInHistorySelectFilter({ label, optionKey, value, onChange }) {
  const options = FILTER_OPTIONS[optionKey] || [];

  return (
    <FormControl size="small" className="stay-in-history-filter">
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

/**
 * Staff Stay-in History Page Component
 * UI/Layout only - Backend developer will add:
 * - API calls for fetching stay-in history data
 * - Filter functionality
 * - Search functionality
 * - Pagination logic
 * - Export functionality
 */
export default function StayInHistory({ onLogout, onNavigate }) {
  // Filter state
  const [filters, setFilters] = React.useState({
    year: "2026",
    month: "all",
    company: "all",
    condoSharing: "all"
  });

  const handleFilterChange = (field) => (event) => {
    setFilters({
      ...filters,
      [field]: event.target.value
    });
  };

  const handleReset = () => {
    setFilters({
      year: "2026",
      month: "all",
      company: "all",
      condoSharing: "all"
    });
  };

  return (
    <PageLayout activeKey="stay-in-history" onLogout={onLogout} onNavigate={onNavigate} className="page-content">
      <PageHeader
        icon={EventAvailableRoundedIcon}
        title="Staff Stay-in History"
        summary="View and track all staff stay-in history records."
      />

      {/* Filters */}
      <Box className="content-box stay-in-history-filters">
        <Box className="stay-in-history-filters-row">
          <StayInHistorySelectFilter 
            label="Year" 
            optionKey="year" 
            value={filters.year}
            onChange={handleFilterChange("year")}
          />
          <StayInHistorySelectFilter 
            label="Month" 
            optionKey="month" 
            value={filters.month}
            onChange={handleFilterChange("month")}
          />
          <StayInHistorySelectFilter 
            label="Company" 
            optionKey="company" 
            value={filters.company}
            onChange={handleFilterChange("company")}
          />
          <StayInHistorySelectFilter 
            label="Condo Sharing" 
            optionKey="condoSharing" 
            value={filters.condoSharing}
            onChange={handleFilterChange("condoSharing")}
          />
          <Box className="stay-in-history-button-group">
            <Button variant="contained" startIcon={<SearchRoundedIcon />}>
              Search
            </Button>
            <Button variant="outlined" startIcon={<RestartAltRoundedIcon />} onClick={handleReset}>
              Reset
            </Button>
            <Button variant="outlined" startIcon={<GetAppRoundedIcon />}>
              Export
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Data Table */}
      <DataTableCard
        title="Stay-in History Records"
        showExport={false}
        totalEntries={STAY_IN_HISTORY_DATA.length}
        startEntry={1}
        endEntry={STAY_IN_HISTORY_DATA.length}
        currentPage={1}
        totalPages={1}
      >
        <TableContainer className="data-table-wrapper">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>EID</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Nickname</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Ranking</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Division</TableCell>
                <TableCell>Department</TableCell>
                <TableCell>Team</TableCell>
                <TableCell>Nationality</TableCell>
                <TableCell>On Board Date</TableCell>
                <TableCell>Last Dorm</TableCell>
                <TableCell>Condo Sharing</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {STAY_IN_HISTORY_DATA.map((record) => (
                <TableRow hover key={record.id}>
                  <TableCell>{record.eid}</TableCell>
                  <TableCell>{record.fullName}</TableCell>
                  <TableCell>{record.nickname}</TableCell>
                  <TableCell>{record.gender}</TableCell>
                  <TableCell>{record.ranking}</TableCell>
                  <TableCell>{record.designation}</TableCell>
                  <TableCell>{record.company}</TableCell>
                  <TableCell>{record.division}</TableCell>
                  <TableCell>{record.department}</TableCell>
                  <TableCell>{record.team}</TableCell>
                  <TableCell>{record.nationality}</TableCell>
                  <TableCell>{record.onBoardDate}</TableCell>
                  <TableCell>{record.lastDorm}</TableCell>
                  <TableCell>{record.condoSharing}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DataTableCard>
    </PageLayout>
  );
}
